import React from "react";
import { connect } from "react-redux";

import RadioButton from "../inputform/RadioButton";
import { IAppState } from "../../state/Store";
import { DisplayType, DisplayTypeEntry } from "../../types/system/DisplayType";
import { setWorking } from "../../state/system/Display";
import Checkbox from "../inputform/Checkbox";
import Panel from "../panels/Panel";
import { Side } from "../../types/system/Layout";

interface DisplaySettingMainSectionProps {
    setting: DisplayType;
    setWorking: (display: Partial<DisplayType>) => void;
}

interface DisplaySettingMainSectionState {}

class DisplaySettingMainSection extends React.Component<
    DisplaySettingMainSectionProps,
    DisplaySettingMainSectionState
> {
    nameCycle(value: boolean, set?: DisplayTypeEntry) {
        if (value === set.order) {
            let value = set.format;
            value = value < 4 ? value + 1 : 0;
            this.props.setWorking({
                type: this.props.setting.type,
                twoName: {
                    format: value,
                },
            });
        }
    }

    nameDisplay(value: boolean, set?: DisplayTypeEntry) {
        switch (value === set.order ? set.format : -1) {
            case 0:
                return "First Name";
            case 1:
                return "First Name Middle Initial";
            case 2:
                return "First Name Middle Name";
            case 3:
                return "First Initial Middle Initial";
            case 4:
                return "First Initial";
            default:
                return "Last Name";
        }
    }

    buildExample(setting: DisplayType) {
        return setting.example((code, name1, name2, name3, title) => {
            return `${this.buildExampleValue(
                Number(setting.value),
                code,
                name1,
                setting.twoName?.order,
                setting.twoName?.format,
                name2,
                name3,
                setting.titles?.value,
                title,
            )}${this.buildSuffix(setting)}`;
        });
    }

    buildExampleValue(
        option: number,
        code: string,
        name: string,
        twoNames: boolean | undefined,
        twoNamesFormat: number | undefined,
        middleName: string,
        secondName: string,
        title: boolean | undefined,
        titleValue: string,
    ) {
        name =
            twoNames !== undefined
                ? this.buildName(
                      twoNames,
                      twoNamesFormat,
                      name,
                      middleName,
                      secondName,
                      title,
                      titleValue,
                  )
                : name;
        switch (Number(option)) {
            case 1:
                return code;
            case 2:
                return name;
            case 3:
                return `${name} / ${code}`;
            default:
                return "";
        }
    }

    buildName(
        mode: boolean,
        format: number,
        name1: string,
        name2: string,
        name3: string,
        title: boolean,
        titleValue: string,
    ) {
        let first = name1;

        switch (Number(format)) {
            case 0:
                first = name1;
                break;
            case 1:
                first = name1 + " " + this.buildInitial(name2);
                break;
            case 2:
                first = name1 + " " + name2;
                break;
            case 3:
                first =
                    this.buildInitial(name1) + " " + this.buildInitial(name2);
                break;
            case 4:
                first = this.buildInitial(name1);
                break;
        }

        return (
            (title ? titleValue + " " : "") +
            (mode ? first + " " + name3 : name3 + ", " + first)
        );
    }

    buildInitial(name: string) {
        return name.length > 0 ? name.substring(0, 1) : name;
    }

    buildSuffix(setting: DisplayType) {
        if (setting.additional?.length > 0) {
            let result = "";
            for (const add of setting.additional)
                if (add.value) result += " / " + add.example;
            return result;
        } else {
            return "";
        }
    }

    render() {
        return (
            <Panel
                bufferSide={Side.All}
                className="full flex-column bottom-clearance-small">
                <h2
                    style={{
                        margin: "0 0 3px",
                    }}>
                    {this.props.setting.name}
                </h2>

                <div className="flex">
                    <div className="col">
                        <div className="swapbox">
                            <div className="flex-row split-button">
                                <RadioButton
                                    className="col text-center"
                                    name={this.props.setting.type}
                                    value="1"
                                    label="Code"
                                    checked={this.props.setting.value === "1"}
                                    onChange={value =>
                                        this.props.setWorking({
                                            type: this.props.setting.type,
                                            value: value,
                                        })
                                    }
                                />
                                <RadioButton
                                    className="col text-center"
                                    name={this.props.setting.type}
                                    value="2"
                                    label="Name"
                                    checked={this.props.setting.value === "2"}
                                    onChange={value =>
                                        this.props.setWorking({
                                            type: this.props.setting.type,
                                            value: value,
                                        })
                                    }
                                />
                                <RadioButton
                                    className="col text-center"
                                    name={this.props.setting.type}
                                    value="3"
                                    label="Both"
                                    checked={this.props.setting.value === "3"}
                                    onChange={value =>
                                        this.props.setWorking({
                                            type: this.props.setting.type,
                                            value: value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        {this.props.setting.twoName && (
                            <div className="swapbox top-clearance-small">
                                <h3>Format:</h3>
                                <div className="flex-row spaced">
                                    <span
                                        className="val"
                                        onClick={() =>
                                            this.nameCycle(
                                                true,
                                                this.props.setting.twoName,
                                            )
                                        }>
                                        {this.nameDisplay(
                                            true,
                                            this.props.setting.twoName,
                                        )}
                                    </span>
                                    <span>
                                        <i
                                            className="swapper center noselect"
                                            onClick={() =>
                                                this.props.setWorking({
                                                    type: this.props.setting
                                                        .type,
                                                    twoName: {
                                                        order: !this.props
                                                            .setting.twoName
                                                            ?.order,
                                                    },
                                                })
                                            }>
                                            swap_horiz
                                        </i>
                                    </span>
                                    <span
                                        className="val"
                                        onClick={() =>
                                            this.nameCycle(
                                                false,
                                                this.props.setting.twoName,
                                            )
                                        }>
                                        {this.nameDisplay(
                                            false,
                                            this.props.setting.twoName,
                                        )}
                                    </span>
                                </div>
                                {this.props.setting.titles && (
                                    <Checkbox
                                        label="Include title"
                                        value={this.props.setting.titles.value}
                                        onChange={value =>
                                            this.props.setWorking({
                                                type: this.props.setting.type,
                                                titles: {
                                                    value: value,
                                                },
                                            })
                                        }
                                    />
                                )}
                            </div>
                        )}
                        {this.props.setting.additional?.some(
                            item => item.show,
                        ) && (
                            <div className="swapbox top-clearance-small">
                                <h3>Show Additional Information</h3>
                                {this.props.setting.additional
                                    .filter(
                                        item =>
                                            item.title().length > 0 &&
                                            item.show,
                                    )
                                    .map((additionalSetting, index) => (
                                        <div
                                            key={index}
                                            className="StudInfoOpt">
                                            <Checkbox
                                                label={additionalSetting.title()}
                                                value={additionalSetting.value}
                                                onChange={value =>
                                                    this.props.setWorking({
                                                        type: this.props.setting
                                                            .type,
                                                        additional: [
                                                            ...this.props.setting.additional.slice(
                                                                0,
                                                                index,
                                                            ),
                                                            {
                                                                ...additionalSetting,
                                                                value: value,
                                                            },
                                                            ...this.props.setting.additional.slice(
                                                                index + 1,
                                                            ),
                                                        ],
                                                    })
                                                }
                                            />
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>

                    <div className="col-pane flex-row-reverse align-i-center examplebox">
                        <div className="cal-tooltip ng-scope mouse">
                            <div>
                                <div className="tt-head">
                                    <div className="headings">
                                        <div>
                                            <span>
                                                {this.buildExample(
                                                    this.props.setting,
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="example">Example:</span>
                    </div>
                </div>
            </Panel>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const {} = state;
    return {};
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        setWorking: (display: Partial<DisplayType>) =>
            dispatch(setWorking(display)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DisplaySettingMainSection);
